import { ABMConsultaType, GetABMCONSULTADispatchTypes, GET_ABMCONSULTA_FAIL, GET_ABMCONSULTA_LOADING, GET_ABMCONSULTA_SUCCESS } from './ABMConsultaActionsTypes';

export interface ABMConsultaDefaultStateI {
    loading : boolean,
    abmconsulta? : ABMConsultaType[] | undefined
}

const defaultState : ABMConsultaDefaultStateI = 
{
    loading : false
};

const ABMConsultaReducer = (state: ABMConsultaDefaultStateI = defaultState, action:GetABMCONSULTADispatchTypes): ABMConsultaDefaultStateI =>{

    switch (action.type) {
        case GET_ABMCONSULTA_FAIL:
            return {
                loading:false
            }
            break;
        case GET_ABMCONSULTA_LOADING:
            return {
                loading:true
            }
            break;
        case GET_ABMCONSULTA_SUCCESS:
            return {
                loading:false,
                abmconsulta:action.payload
            }
            break;
        default:
            return state
            break;
    }
    return state;
}

export default ABMConsultaReducer;